import { ArrayOr, Assets, type AssetsManifest } from 'pixi.js';

export class Preloader {
    private initiated = false;

    constructor(
        public readonly manifest: AssetsManifest,
        private basePath?: string,
    ) {}

    private async init() {
        if (this.initiated) return;

        await Assets.init({
            manifest: this.manifest,
            basePath: this.basePath,
            preferences: {
                preferWorkers: true, // use Web Workers for image loads/decoding
                preferCreateImageBitmap: true, // off-main-thread decode
            },
        });
        this.initiated = true;
    }

    async load(bundles: ArrayOr<string>, onProgress?: (progress: number) => void): Promise<void> {
        if (!this.initiated) {
            await this.init();
        }

        await Assets.loadBundle(bundles, (progress) => onProgress?.(progress * 100));

        onProgress?.(100);
    }

    get cache(): typeof Assets.cache {
        return Assets.cache;
    }

    getAsset<T>(key: string): T | null {
        return Assets.cache.get(key) ?? null;
    }
}
